// extracted by mini-css-extract-plugin
module.exports = {"productControlButtonsDesTimer":"styles-module-productControlButtonsDesTimer--iFMGg","productControlButton":"styles-module-productControlButton--PKhVw"};